<ng-container>
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">{{ title }}</span>

        <button
            mat-icon-button
            type="button"
            aria-label="Chiudi"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    @if (isViewMode) {
        <mat-dialog-content class="content content-view">
            <div class="note-view-card">
                <span class="body-small">{{ data.note?.data | date:'dd/MM/yyyy HH:mm' }}</span>
                <span class="body-medium-emphasized">{{ data.note?.titolo }}</span>
                <span class="body-small">{{ data.note?.testo }}</span>
            </div>
        </mat-dialog-content>
    } @else {
        <mat-dialog-content class="content" [formGroup]="noteForm">
            <mat-form-field appearance="outline">
                <mat-label>Titolo nota</mat-label>
                <input matInput formControlName="titolo">
            </mat-form-field>

            <mat-form-field appearance="outline" class="text-area-custom">
                <mat-label>Testo nota</mat-label>
                <textarea matInput formControlName="testo" rows="4"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Data nota</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="data" placeholder="GG/MM/AAAA">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <div class="note-option-card">
                <div class="note-option-card-content">
                    <span class="body-medium-emphasized">Aggiungi ad ogni richiesta autorizzazione ordine</span>
                    <span class="body-small">La nota sara proposta automaticamente quando si crea una richiesta autorizzazione ordine per questo cliente.</span>
                </div>

                <mat-slide-toggle formControlName="addOrdine" aria-label="Aggiungi ad ogni richiesta autorizzazione ordine"></mat-slide-toggle>
            </div>
        </mat-dialog-content>
    }

    <mat-dialog-actions class="buttons-container" [class.buttons-container-view]="isViewMode">
        @if (isViewMode) {
            <button matButton="filled" type="button" (click)="onEdit()">Modifica</button>
            <button matButton type="button" (click)="onClose()">Chiudi</button>
        } @else {
            <button matButton type="button" (click)="onReset()">Cancella</button>
            <button matButton="filled" type="button" (click)="onApply()">Salva</button>
        }
    </mat-dialog-actions>
</ng-container>
